















































import Component from 'vue-class-component'
import Vue from 'vue'
import DefaultHeader from '@/main/default-header.vue'
import UnifyPage from '@/shared/components/unify/unify-page.vue'

@Component({
  name: 'respondeco-impact',
  components: { UnifyPage, DefaultHeader },
})
export default class Impact extends Vue {}
